import { FaRegUserCircle } from "react-icons/fa";
import { AiFillProduct } from "react-icons/ai";
import { MdCategory } from "react-icons/md";
import { GiVerticalBanner } from "react-icons/gi";
import { IoIosSettings } from "react-icons/io";
import { RiDashboard2Line } from "react-icons/ri";
import { FaComments } from "react-icons/fa6";
import { LuCircleUserRound } from "react-icons/lu";
import { FaFileInvoice } from "react-icons/fa6";
import { RiSecurePaymentLine } from "react-icons/ri";
import { BiCategory } from "react-icons/bi";
import { TiMessages } from "react-icons/ti";

export const dataSidebar = [
  {
    link: "/",
    title: "Dashboard",
    icon: <RiDashboard2Line />,
  },
  {
    title: "Site Banner",
    icon: <GiVerticalBanner />,
    subItem: [
      {
        link: "/all-banner",
        title: "All Banner",
        icon: <AiFillProduct />,
      },
      {
        link: "/multi-banner",
        title: "Multi Banner",
        icon: <AiFillProduct />,
      },
      {
        link: "/main-banner",
        title: "Main Banner",
        icon: <AiFillProduct />,
      },
      {
        link: "/orderFood-banner",
        title: "Food Banner",
        icon: <AiFillProduct />,
      },
      {
        link: "/groceryStore-banner",
        title: "Market Banner",
        icon: <AiFillProduct />,
      },
    ],
  },
  {
    link: "/user",
    title: "User",
    icon: <FaRegUserCircle />,
  },
  {
    link: "/seller",
    title: "Seller",
    icon: <LuCircleUserRound />,
  },
  {
    // link: "/product",
    // link: "/seller-product",
    title: "Products",
    icon: <AiFillProduct />,
    subItem: [
      {
        link: "/orders-product",
        title: "Food Products",
        icon: <AiFillProduct />,
      },
      {
        link: "/grocery-product",
        title: "Grocery Products",
        icon: <AiFillProduct />,
      },
    ],
  },
  {
    link: "/category",
    title: "Category",
    icon: <MdCategory />,
  },
  {
    link: "/brands",
    title: "Brand",
    icon: <BiCategory />,
  },
  {
    link: "/comment",
    title: "Comment",
    icon: <FaComments />,
  },
  {
    link: "/invoice",
    title: "Invoice",
    icon: <FaFileInvoice />,
  },
  {
    link: "/ticket",
    title: "Ticket",
    icon: <TiMessages />,
  },
  {
    link: "/payment-methode",
    title: "Payment Method",
    icon: <RiSecurePaymentLine />,
  },
  {
    link: "/Setting",
    title: "Setting",
    icon: <IoIosSettings />,
  },
];
